<template>
    <div>
        <div class="companypng"><img src="https://www.tsintell.com/img/cpBG.jpg" alt=""></div>
        <div>
            <div class="product-section">
                <!-- 顶部按钮 -->
                <div class="button-group">
                    <el-button v-for="(tab, index) in tabs" :key="index" :class="{ active: activeTab === index }"
                        @click="activeTab = index">
                        {{ tab }}
                    </el-button>
                </div>

                <!-- 底部内容区域 -->
                <div class="content-area">
                    <!-- 近视防控产品 -->
                    <div v-if="activeTab === 0">
                        <div class="product-card" @mouseover="hover = true" @mouseleave="hover = false">
                            <!-- 左侧图片 -->
                            <div class="image-section">
                                <img src="../assets/cptu1.jpg" alt="AI视力智能快速筛查仪" class="product-image">
                            </div>
                            <!-- 右侧文字 -->
                            <div class="text-section">
                                <h2 class="product-title">AI视力智能快速筛查仪</h2>
                                <ul class="features-list">
                                    <li>国家重点研发计划成果</li>
                                    <li>发明专利</li>
                                    <li>人工智能用眼行为识别</li>
                                    <li>近视防控抓手</li>
                                    <li>最高级别安全认证</li>
                                </ul>
                                <el-button type="primary" class="detail-btn">查看详情</el-button>
                            </div>
                        </div>
                        <div class="product-card">
                            <!-- 左侧图片 -->
                            <div class="image-section">
                                <img src="@/assets/cptu2.jpg" alt="Eye-Monitor用眼行为矫正仪" class="product-image">
                            </div>
                            <!-- 右侧文字 -->
                            <div class="text-section">
                                <h2 class="product-title">AI智能液晶视力表</h2>
                                <ul class="features-list">
                                    <li>国家重点研发计划成果</li>
                                    <li>发明专利</li>
                                    <li>人工智能识别手势</li>
                                    <li>近视防控抓手</li>
                                    <li>最高级别安全认证</li>
                                </ul>
                                <el-button type="primary" class="detail-btn" @click="EyeChartClick">查看详情</el-button>
                            </div>
                        </div>
                    </div>


                    <!-- 医疗系统软件 -->
                    <div v-if="activeTab === 1">
                        <div class="product-card">
                            <!-- 左侧图片 -->
                            <div class="image-section">
                                <img src="@/assets/gscptu1.jpg" alt="Eye-Monitor用眼行为矫正仪" class="product-image">
                            </div>
                            <!-- 右侧文字 -->
                            <div class="text-section">
                                <h2 class="product-title">近视防控筛查与大数据系统</h2>
                                <ul class="features-list">
                                    <li>0-18岁</li>
                                    <li>三级监测 配套使用产品 / 三级预警 / 三级防控</li>
                                    <li>实时数据质控 / 实时统计数据报告 / 大数据分析预警 </li>
                                    <li>数据安全三级加密保护</li>
                                    <li>最高级别安全认证</li>
                                </ul>
                                <el-button type="primary" class="detail-btn" @click="goToSystemDetails">查看详情</el-button>
                            </div>
                        </div>
                    </div>
                    <!-- 耗材 -->
                    <div v-if="activeTab === 2">
                        <div class="product-card">
                            <!-- 左侧图片 -->
                            <div class="image-section">
                                <img src="@/assets/cptu3.jpg" alt="Eye-Monitor用眼行为矫正仪" class="product-image">
                            </div>
                            <!-- 右侧文字 -->
                            <div class="text-section">
                                <h2 class="product-title">医用级遮眼板</h2>
                                <ul class="features-list">
                                    <li>0-18岁</li>
                                    <li>三级监测 配套使用产品 / 三级预警 / 三级防控</li>
                                    <li>实时数据质控 / 实时统计数据报告 / 大数据分析预警 </li>
                                    <li>数据安全三级加密保护</li>
                                    <li>最高级别安全认证</li>
                                </ul>
                                <el-button type="primary" class="detail-btn" @click="Consumables">查看详情</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
export default {
    data() {
        return {
            tabs: ['设备', '软件', '耗材'], // 顶部按钮
            activeTab: 0,// 当前选中的按钮索引
            hover: false,
        };
    },
    components: {
        Footer
    },
    methods: {
        goToSystemDetails() {
            this.$router.push('/SystemDetails'); // 跳转到目标页面
        },
        EyeChartClick(){
            this.$router.push('/EyeChart');
        },
        Consumables(){
            this.$router.push('/ConsumablesDetails');
        }

    }

};
</script>

<style>
/* 鼠标特效 */
.product-card:hover {
    transform: translateY(-5px);
}

/* 悬停效果 */
.hover-effect {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
}

/* 选择器 */
.image-section {
    flex: 1;
    padding: 10px;
}

.companypng {
    margin-top: 60px;
}

.product-section {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.button-group {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.button-group .el-button {
    margin: 0 10px;
    font-size: 16px;
    border: none;
    background-color: transparent;
    color: #333;
}

.button-group .el-button.active {
    color: #409EFF;
    /* 选中按钮的颜色 */
    border-bottom: 2px solid #409EFF;
}

.content-area {
    margin-top: 20px;
}


.detail-btn {
    margin-top: 10px;
}

/* 产品中的样式 */
.product-card {
    display: flex;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
    background-color: #f4f5f7;
    margin-top: 30px;
}

.image-section {
    flex: 1;
    padding: 10px;
}

.product-image {
    width: 360px;
    height: 300px;
    border-radius: 8px;
}

.text-section {
    flex: 1;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.product-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #001529;
}

.features-list {
    list-style: none;
    padding: 0;
    margin-bottom: 20px;
}

.features-list li {
    font-size: 16px;
    color: #606266;
    margin: 8px 0;
}

.detail-btn {
    align-self: flex-start;
    margin-top: 10px;
}
</style>